<template>
    <div>
        <el-dialog
            title="添加有效客户"
            :visible.sync="showpicker"
            width="800px"
            :before-close="back">
            <div class="warp">
                <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="mini">
                    <el-form-item label="用户姓名" prop="name">
                        <el-input v-model="form.name" maxlength="16" placeholder="请填写客户姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机" prop="telephone">
                        <el-input v-model="form.telephone" type="number" maxlength="11" placeholder="请填写客户手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                        <el-radio-group v-model="form.sex" >
                            <el-radio label="男" border>男</el-radio>
                            <el-radio label="女" border>女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="客户等级">
                        <el-select v-model="form.level" value-key="name" placeholder="请选择客户等级" clearable filterable>
                            <el-option label="A:需求迫切" value="A"></el-option>
                            <el-option label="B:观望中" value="B"></el-option>
                            <el-option label="C:无购房需求" value="C"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="来源">
                        <el-select v-model="form.source" value-key="name" placeholder="请选择客户来源" clearable filterable allow-create>
                            <el-option v-for="(item, index) in sources"
                                :key="index"
                                :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                        <p class="text text-hit"><span class="el-icon-warning">支持自己手动填写</span></p>
                    </el-form-item>
                    <el-form-item label="意向区域">
                        <el-cascader :options="regions" v-model="checkregion" clearable @change="changeregion" :props="{label: 'label', value: 'label', children: 'children'}">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="意向楼盘">
                        <div class="flex-box">
                            <el-input v-model="form.projectname" placeholder="请点击右侧选择楼盘" clearable></el-input>
                            <tutor-project @getProject="getProject" v-if="regions" :regions="regions"></tutor-project>
                        </div>
                    </el-form-item>
                    <el-form-item label="首付预算">
                        <div class="flex-box">
                            <el-slider class="slider" v-model="form.downpayment" :min="1" :max="500" :step="1" range></el-slider>
                            <span class="text">万</span>
                        </div>
                        
                    </el-form-item>
                    <el-form-item label="总预算">
                        <div class="flex-box">
                            <el-slider class="slider" v-model="form.totalpayment" :min="10" :max="2000" :step="10" range></el-slider>
                            <span class="text">万</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="买房用途">
                        <el-checkbox-group v-model="form.tags">
                            <el-checkbox v-for="(item, index) in tags" :key="index" :label="item" border>
                                {{item}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="房源类型">
                        <el-select v-model="form.housetype" value-key="name" placeholder="请选择意向房源类型" clearable filterable allow-create>
                            <el-option v-for="(item, index) in housetypes"
                                :key="index"
                                :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                        <p class="text text-hit"><span class="el-icon-warning">支持自己手动填写</span></p>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.remark" placeholder="这里填写客户的基本需求，比如学区房，要汉口北的，120平，200万预算等"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="confirm">立即添加</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import tutorProject from '../../../components/tutor-project.vue';
export default {
    components: { 
        tutorProject,
    },
    data() {
        var validatetelephone = (rule, value, callback) => {
            if (!(/^1(3|4|5|7|8)\d{9}$/.test(value))){
                callback(new Error('手机号格式不正确'));
            }
            callback();
        }
        return {
            showpicker: true,
            form: {
                name: '',
                telephone: '',
                sex: '男',
                source: '',
                projectname: '',
                projectid: '',
                remark: '',
                region: '',
                city: '',
                downpayment: [10, 50],
                totalpayment: [100, 300],
                tags: [],
                housetype: '',
                level:'',
            },
            rules: {
                name: [
                    { required: true, message: '客户姓名必须填写', trigger: 'blur' },
                ],
                telephone: [
                    { required: true, message: '请填写客户手机号', trigger: 'blur' },
                    { validator: validatetelephone, trigger: 'blur'}
                ]
            },
            sources: [
                {name: '真会投资/微信'},
                {name: '公众号/浩哥看市'},
                {name: '公众号/浩哥观商业'},
                {name: '公众号/真会投资'},
                {name: '新媒/抖音'},
                {name: '公众号/黄峰淘房'},
                {name: '视频号/胡二筒'},
                {name: '公众号/张涛地产观'},
                {name: '公众号/阿松评楼'},
                {name: '公众号/老欢咵房'},
                {name: '公众号/马哥说房'},
                {name: '合作/壹楼'},
                {name: '合作/亿房'},
                {name: '合作/嘟嘟租房'},
                {name: '合作/其他'},
            ],
            housetypes: [
                {name: '商铺'},
                {name: '公寓'},
                {name: '写字楼'},
                {name: '住宅'},
                {name: '厂房'},
            ],
            regions: [],
            tags: ['刚需', '结婚', '投资', '改善', '养老', '孩子上学', '其他'],
            checkregion: [],
        }
    },
    mounted () {
        this.getcitys();
    },
    methods: {
        confirm() {
            this.$refs.form.validate((valid)=>{
                if (valid) {
                    var form = this.form;
                    var params = {
                        name: form.name,
                        telephone: form.telephone,
                        sex: form.sex,
                        source: form.source,
                        projectname: form.projectname,
                        projectid: form.projectid,
                        remark: form.remark,
                        region: form.region,
                        city: form.city,
                        downpayment: JSON.stringify(form.downpayment),
                        totalpayment: JSON.stringify(form.totalpayment),
                        tags: JSON.stringify(form.tags),
                        housetype: form.housetype,
                        level: form.level,
                    }
                    this.$api.addProjectCientVsValid(params).then(
                        data=>{
                            this.$message.success(data);
                            this.$router.go(-1);
                        }
                    )
                }
            })
            
        },
        changeregion(val) {
            this.form.city = val[0];
            this.form.region = val[1]+'-'+val[2];
        },
        getcitys() {
            this.$api.getCityList('').then(
                data=>{
                    this.regions = data;
                }
            )
        },
        back() {
            this.$confirm('信息未保存，是否确定退出')
                .then(_=>{
                    this.$router.go(-1);
                })
                .catch(_=>{})
        },
        getProject(project) {
            this.form.projectname = project.name;
            this.form.projectid = project._id['$oid'];
            this.$forceUpdate();
        },
    },
}
</script>

<style lang="scss" scoped>
.text-hit{
    color: #e6a23c;
}
.slider{
    width: 100%;
}
</style>